import { render, staticRenderFns } from "./InvoicesReceipts.vue?vue&type=template&id=bd01d0a8&scoped=true"
import script from "./InvoicesReceipts.ts?vue&type=script&lang=js&external"
export * from "./InvoicesReceipts.ts?vue&type=script&lang=js&external"
import style0 from "./InvoicesReceipts.vue?vue&type=style&index=0&id=bd01d0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd01d0a8",
  null
  
)

export default component.exports